import React, { useContext, useState } from 'react'
import CommentItem from '../comment-item'
import AddComment from '../add-comment'
import { IComment, IDose } from 'daily-dose-common'
import { Button, Typography } from '@material-ui/core'
import { collectIdAndDocs } from '../../utilities'
import firebase from 'firebase'
import { FirestoreContext } from '../../providers/firestore-provider'

interface ICommentListProps {
  comments: IComment[]
  commentsRef: any
  commentsRefByDate: any
  dose: IDose
}

const LOAD_MORE_NUMBER = 5

const CommentList = ({
  comments,
  commentsRef,
  commentsRefByDate,
  dose,
}: ICommentListProps) => {
  const { currentUser } = useContext(FirestoreContext)
  const [loading, setLoading] = useState(false)
  const [commentsEnd, setCommentsEnd] = useState(false)
  const [localComments, setLocalComments] = useState(comments)
  const getMoreComments = async () => {
    setLoading(true)
    const last = localComments[localComments.length - 1]
    const cursor = last.createdAt
    const commentsQuery = commentsRefByDate
      .startAfter(cursor)
      .limit(LOAD_MORE_NUMBER)

    const newComments = (await commentsQuery.get()).docs.map(collectIdAndDocs)

    setLocalComments(localComments.concat(newComments))
    setLoading(false)

    if (newComments.length < LOAD_MORE_NUMBER) {
      setCommentsEnd(true)
    }
  }

  const onCreateComment = (content: string) => {
    // TODO: Refactor. Remove !
    if (!!commentsRef && currentUser) {
      const newComment: IComment = {
        content,
        createdAt: firebase.firestore.Timestamp.now(),
        updatedAt: firebase.firestore.Timestamp.now(),
        userId: currentUser.id!,
        doseId: dose.id!,
        circleId: dose.circleId,
        user: {
          displayName: currentUser.displayName!,
          email: currentUser?.email,
          photoURL: currentUser?.photoURL,
          id: currentUser.id!,
        },
        likeCount: 0,
      }

      commentsRef
        .add(newComment)
        .then((docRef) => {
          const newCommentWithId = {
            ...newComment,
            id: docRef.id,
          }
          setLocalComments([...[newCommentWithId], ...localComments])
        })
        .catch((error) => {
          console.warn('An error happened while adding a comment ', error)
        })
    }
  }

  const loadMoreComments = () => {
    if (!loading && !commentsEnd && localComments.length > 1) {
      return (
        <Button
          onClick={getMoreComments}
          color="primary"
          style={{ textTransform: 'none' }}
        >
          Load more comments
        </Button>
      )
    }

    if (loading)
      return (
        <Typography variant="caption" color="textSecondary" component="p">
          Loading...
        </Typography>
      )

    if (commentsEnd)
      return (
        <Typography variant="caption" color="textSecondary" component="p">
          No more comments. You are up to date 😃
        </Typography>
      )
  }
  return (
    <>
      <section className="Comments">
        <AddComment onCreate={onCreateComment} />
        {localComments.map((comment: IComment) => (
          <CommentItem commentItem={comment} key={comment.id} />
        ))}
        {loadMoreComments()}
      </section>
    </>
  )
}

export default CommentList
